import { ClientItem } from 'owa-mail-store';

export default function getUserNoteContent(
    keyword: string,
    instance: number,
    item: ClientItem
): string {
    for (const note of item.userNoteData) {
        if (keyword === note.keyword && instance === note.instance) {
            return note.content;
        }
    }
    return null;
}
